var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.discountPix())?_c('discount-pix',[_c('b',[_vm._v(_vm._s(_vm.discountPix())+"% OFF")]),_vm._v(" no PIX\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }